<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <Form  @submit="addReclamation" :validation-schema="reclamationSchema">
          <div class="row">

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="code" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le  code"/>
                  <ErrorMessage name="code" class="text-danger"/>
                </div>
              </div>

            
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Superficie<span class="text-danger">*</span>
                  </label>
                  <Field name="superficie" type="number" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la superficie"/>
                  <ErrorMessage name="superficie" class="text-danger"/>
                </div>
              </div>
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Loyer de base<span class="text-danger">*</span>
                  </label>
                  <Field name="loyerBase" type="number" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le loyer de base"/>
                  <ErrorMessage name="loyerBase" class="text-danger"/>
                </div>
              </div>
             
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Categorie d'activité<span class="text-danger">*</span>
                </label>
                <Field name="categorieActivite" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="categorieActiviteOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner la categorie activite"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="categorieActivite" class="text-danger" />
              </div>
            </div>

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Marché<span class="text-danger">*</span>
                </label>
                <Field name="marche" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="marcheOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner le marché"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="marche" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Type d'emplacement<span class="text-danger">*</span>
                </label>
                <Field name="type" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="typeOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner le type"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="type" class="text-danger" />
              </div>
            </div>

            <div class="col-md-12 mt-3">
              <div class="d-flex align-items-center ">
                <button class="btn btn-success me-3" type="submit">
                  Ajouter place
                </button>
                <router-link to="/liste-place" class=" btn btn-danger "><i
                    class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </template>
  <script lang="ts">
  import { defineComponent, onMounted, ref, watch } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  import { error, success } from '@/utils/utils';
  import { useRouter } from 'vue-router';
  import Multiselect from '@vueform/multiselect';
  export default defineComponent({
    name: "AddPlace",
    components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    setup: () => {
      const placeSchema = Yup.object().shape({
  code: Yup.string().required("Code est obligatoire."),
  //reference: Yup.string().required("Reference est obligatoire."),
  superficie: Yup.string().required("Superficie est obligatoire."),
  loyerBase: Yup.string().required("Loyer de base est obligatoire."),
  categorieActivite: Yup.string().required("Categorie activite est obligatoire."),
  marche: Yup.string().required("Marche est obligatoire."),
  type: Yup.string().required("Type est obligatoire."),
 // statut:Yup.string().required("Statut est obligatoire")
});

      const placeForm = ref(null);
      const code= ref();
      const reference = ref();
      const superficie= ref();
      const marche = ref();
      const npi= ref();
      const categorieActivite= ref();
      const type = ref();
      const statut = ref();
      const categorieActiviteOptions = ref();
      const marcheOptions = ref();
      const typeOptions = ref();
      const router = useRouter();

      onMounted(() => {
        getAllCategorieActivites();
        getAllMarches();
        getAllTypes();
            });

      const addPlace = async (values, {resetForm}) => {
        console.log("values");
        ApiService.post("/places",values)
          .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              resetForm();
              router.push({ name: "ListePlacePage" });
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
      };
    
    const getAllMarches = async () => {
          try{
          const response = await ApiService.get('/all/marches');
          const marchesData = response.data.data.data;
          console.log('Data', marchesData)
          marcheOptions.value = marchesData.map((marche) => ({
            value: marche.id,
            label: marche.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }
         
    const getAllTypes = async () => {
          try{
          const response = await ApiService.get('/all/types');
          const typesData = response.data.data.data;
          console.log('Data', typesData)
          typeOptions.value = typesData.map((type) => ({
            value: type.id,
            label: type.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }
    const getAllCategorieActivites = async () => {
          try{
          const response = await ApiService.get('/all/categorieActivites');
          const categorieActivitesData = response.data.data.data;
          console.log('Data', categorieActivitesData)
          categorieActiviteOptions.value = categorieActivitesData.map((categorieActivite) => ({
            value: categorieActivite.id,
            label: categorieActivite.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }
      return { placeSchema,
         addPlace,
         getAllTypes,
          placeForm,
          categorieActivite,
          categorieActiviteOptions,
          marche,
          type,
          marcheOptions,
          typeOptions,
          statut,
        };
    },
  });
  </script>